import { z } from 'zod'
import { RoleEntityDtoSchema } from './RoleEntityDto'

export type RoleName = 'Admin' | 'System' | 'Team Member' | 'Guest' | 'Support' | 'SuperAdmin' | (string & {})

export namespace RoleDto {
   export const entitySchema = RoleEntityDtoSchema
   export type entity = z.output<typeof RoleEntityDtoSchema>

   export const defaultOrgTypeRoleSchema = RoleDto.entitySchema.pick({ id: true, name: true })
   export type defaultOrgTypeRole = z.output<typeof RoleDto.defaultOrgTypeRoleSchema>

   export const roleEditablePropsSchema = RoleDto.entitySchema.pick({ description: true })
   export const roleEditSchema = RoleDto.entitySchema.pick({ id: true }).merge(RoleDto.roleEditablePropsSchema)
   export type roleEdit = z.output<typeof RoleDto.roleEditSchema>

   export const deleteRoleSchema = RoleDto.entitySchema.pick({ id: true })
   export type deleteRole = z.output<typeof RoleDto.deleteRoleSchema>

   export const RoleReorderSchema = RoleDto.entitySchema.pick({ id: true, displayOrder: true })
   export type RoleReorder = z.output<typeof RoleReorderSchema>

   export const RolesReorderDtoSchema = z.array(RoleDto.RoleReorderSchema)
   export type RolesReorderDto = z.output<typeof RoleDto.RolesReorderDtoSchema>

   export const createNameDtoSchema = RoleDto.entitySchema.pick({ name: true })

   export const createSchema = RoleDto.entitySchema.pick({ orgType: true, description: true, name: true })
   export type create = z.output<typeof RoleDto.createSchema>
}
